var exports = {
  "p": "x234b8571--7dec00--list",
};

module.exports = exports;
